import { render, staticRenderFns } from "./add-fun.vue?vue&type=template&id=4de96958&scoped=true"
import script from "./add-fun.vue?vue&type=script&lang=js"
export * from "./add-fun.vue?vue&type=script&lang=js"
import style0 from "./add-fun.vue?vue&type=style&index=0&id=4de96958&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de96958",
  null
  
)

export default component.exports